import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const LoadContainer = Loadable({ loader: () => import('layers/accessible/containers/LoadContainer/LoadContainer'), loading })
const HomePage      = Loadable({ loader: () => import('layers/accessible/pages/HomePage/HomePage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={HomePage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
